import React, { useState } from 'react';
import Footer from './Footer.tsx';

function ContactForm() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = async (event) => {
    event.preventDefault();

    const formDataToSend = new FormData();
    formDataToSend.append('name', formData.name);
    formDataToSend.append('email', formData.email);
    formDataToSend.append('message', formData.message);
    formDataToSend.append('access_key', 'ef90b504-633f-49ab-a00e-2bc90ab868b0');

    const object = Object.fromEntries(formDataToSend);
    const json = JSON.stringify(object);

    const res = await fetch('https://api.web3forms.com/submit', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: json,
    }).then((res) => res.json());

    if (res.success) {
      console.log('Success', res);
      setIsSubmitted(true);
      setFormData({ name: '', email: '', message: '' });
    }
  };

  return (
    <div className="bg-gradient-to-r from-[#EDEDED] to-[#D9D9D9] rounded-b-3xl">
      <div className="min-h-screen flex justify-center p-4">
        <div className="w-full max-w-lg">
          <h2 className="text-6xl font-serif text-center mb-4">Contact us</h2>
          <p className="text-center font-inter leading-[24px] text-lg text-gray-600 mb-16">
            We'd love to hear from you! Whether you have questions, feedback, or business inquiries, feel free to reach out.
          </p>
          <form
            onSubmit={onSubmit}
            className="bg-white border border-[#dedede] p-4 border-[13px] border-transparent rounded-2xl backdrop-blur-sm"
          >
            <div className="mb-4">
              <label
                htmlFor="name"
                className="block text-left text-gray-700 text-base font-semibold mb-2"
              >
                Name
              </label>
              <input
                type="text"
                id="name"
                placeholder="Name"
                className="shadow appearance-none border border-[#AAAAAA] rounded-xl w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-4">
              <label
                htmlFor="email"
                className="block text-gray-700 text-base font-semibold mb-2 text-left "
              >
                Email
              </label>
              <input
                type="email"
                id="email"
                placeholder="Email"
                className="shadow appearance-none border border-[#AAAAAA] rounded-xl w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-6">
              <label
                htmlFor="message"
                className="block text-gray-700 text-base font-semibold mb-2 text-left "
              >
                Message
              </label>
              <textarea
                id="message"
                placeholder="Message"
                className="shadow appearance-none border border-[#AAAAAA] rounded-xl w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                rows="4"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
            </div>
            <div className="flex items-center justify-center">
              <button
                className="bg-gradient-to-r from-[#5AC57B] to-[#15B146] w-full hover:bg-green-700 text-base text-white font-semibold font-inter py-2 px-4 rounded-xl focus:outline-none focus:shadow-outline"
                type="submit"
              >
                Submit
              </button>
            </div>
          </form>
          {isSubmitted && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
              <div className="relative w-full max-w-md bg-white p-6 sm:p-8 rounded-2xl shadow-lg">

                <button
                  onClick={() => setIsSubmitted(false)}
                  className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18.7071 6.70711C19.0976 6.31658 19.0976 5.68342 18.7071 5.29289C18.3166 4.90237 17.6834 4.90237 17.2929 5.29289L12 10.5858L6.70711 5.29289C6.31658 4.90237 5.68342 4.90237 5.29289 5.29289C4.90237 5.68342 4.90237 6.31658 5.29289 6.70711L10.5858 12L5.29289 17.2929C4.90237 17.6834 4.90237 18.3166 5.29289 18.7071C5.68342 19.0976 6.31658 19.0976 6.70711 18.7071L12 13.4142L17.2929 18.7071C17.6834 19.0976 18.3166 19.0976 18.7071 18.7071C19.0976 18.3166 19.0976 17.6834 18.7071 17.2929L13.4142 12L18.7071 6.70711Z" fill="black" />
                  </svg>
                </button>

                <div className="flex justify-center mb-4">
                  <svg width="73" height="72" viewBox="0 0 73 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.5" width="72" height="72" rx="36" fill="#34C759" fillOpacity="0.2" />
                    <path d="M57 34.1714V36.0114C56.9975 40.3243 55.601 44.5208 53.0187 47.9751C50.4363 51.4294 46.8066 53.9564 42.6707 55.1792C38.5349 56.4021 34.1145 56.2552 30.0689 54.7606C26.0234 53.266 22.5693 50.5036 20.2219 46.8856C17.8745 43.2675 16.7596 38.9876 17.0434 34.6841C17.3271 30.3806 18.9944 26.2841 21.7966 23.0056C24.5987 19.7271 28.3856 17.4422 32.5924 16.4917C36.7992 15.5413 41.2005 15.9761 45.14 17.7314M57 20L37 40.02L31 34.02" stroke="#34C759" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>

                <p className="text-center text-2xl font-semibold mb-4">
                  Message Sent Successfully!
                </p>
                <p className="text-center text-base text-[#252525]">
                  Thank you for reaching out to us. We have received your message and will get back to you shortly.
                </p>

                <div className="flex justify-center">
                  <button
                    onClick={() => setIsSubmitted(false)}
                    className="border border-[#555555] py-3 px-6 rounded-xl mt-8 text-[#252525] hover:bg-gray-100"
                  >
                    Close
                  </button>
                </div>

              </div>
            </div>
          )}


        </div>
      </div>
      <Footer />
    </div>
  );
}

export default ContactForm;